import {Link, useLocation} from 'react-router-dom'
import {Selector} from 'components/Selector/Selector'
import styles from './Header.module.scss'
import Logo from 'assets/images/svg/icon_logo.svg'

export const Header =()=> {
    const { pathname } = useLocation()
    const isNews = pathname.includes('news') || pathname.includes('areas-of-work') || pathname.includes('representative')
    const selectCN = isNews ? styles.selector + ' ' + styles.selector_sec : styles.selector

    return (
        <header className={styles.header}>
            <div className="wrapper">
                <div className={styles.wrap}>
                    <Link to='/' className={styles.logo}>
                        <img className={styles.logo_img} src={Logo} alt="" width={112} height={112}/>
                        <div className={styles.logo_title}>
                            Женское движение <br/> «ЕДИНОЙ РОССИИ»
                        </div>
                    </Link>

                    <div className={selectCN}>
                        <Selector />
                    </div>
                </div>
            </div>
        </header>
    )
}
